export const ALLOWED_FUNCTIONAL_KEYS = [
    'Backspace',
    'Delete',
    'ArrowUp',
    'ArrowDown',
    'ArrowLeft',
    'ArrowRight',
    'Tab',
    'Shift',
];
